module.exports = __webpack_public_path__ + "fa-brands-400.19d26f4e4b4fc52d03b8.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/webfonts/fa-brands-400.ttf
// module id = ../../../../../src/assets/fonts/webfonts/fa-brands-400.ttf
// module chunks = styles